import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPartOfFilterOptions = createSelector(
  [(store: RootState) => store.locations.locations],
  (data) => data.filter(({ category, usersCount }) => category?.id == "3")
);
